<template>
    <div v-if="data_type !== 'date'">
        <div class="range-slider-container" ref="rangeSlider">
            <div class="range-slider-inputs">
                <input
                    id="input-with-min"
                    type="number"
                    :value="modelValue.min"
                    @input="validateInput"
                    @change="changeHandler({min: parseInt($event.target.value), max: modelValue.max})"
                >
                <input
                    id="input-with-max"
                    type="number"
                    :value="modelValue.max"
                    @input="validateInput"
                    @change="changeHandler({min: modelValue.min, max: parseInt($event.target.value)})"
                >
            </div>
            <div id="steps-slider" class="range-slider"></div>
        </div>
    </div>
    <div v-else class="between">
        <!-- @@TODO -->
        Calendar
        <!-- <Calendar
            v-model="calendarRange"
            selectionMode="range"
            :manualInput="false"
            dateFormat="dd.mm.yy"
            @date-select="calendarChange"
        />  -->
    </div>
</template>

<script>
import {initRangeSlider} from '@/assets/range-slider'
import '../../../../assets/libs/noUiSlider/nouislider15.5.0.min.css'
// import Calendar from 'primevue/calendar'
// import 'primevue/resources/themes/saga-blue/theme.css'
// import 'primevue/resources/primevue.min.css'
// import 'primeicons/primeicons.css'

export default {
    props: {
        modelValue: {
            default: {
                min: 0,
                max: 0
            }
        },
        options: {
            default: []
        },
        title: String,
        pkey: String,
        data_type: String,
    },
    // components: {Calendar},
    emits: ['update:modelValue', 'change'],
    data() {
        return {
            calendarRange: [],
        }
    },
    beforeMount() {
        if (this.data_type === 'date') {
            this.calendarRange = [this.timestamp(this.modelValue.min === null ? this.options.min : this.modelValue.min), this.timestamp(this.modelValue.max === null ? this.options.max : this.modelValue.max)]
        }
    },
    mounted() {
        if (this.data_type !== 'date') {
            if(this.options.min >= 0 && this.options.max >= 0){
                initRangeSlider.bind(this)(this.$refs.rangeSlider)
            }
        }
    },
    methods: {
        changeHandler(v) {
            this.$emit('update:modelValue', v)
            this.$emit('change')
        },
        validateInput(e) {
            e.target.value = e.target.value.replace(/\D/g, '')
        },
        timestamp(datestr) {
            if (typeof datestr === 'string') {
                const [day, month, year] = datestr.split('.')
                return new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
            }else {
                return null
            }
        },
        calendarChange() {
            const [min, max] = this.calendarRange
            if (!min || !max) {
                console.log('missing one value in diapason')
            }
            const value = {
                min: `${min.getDate()}.${min.getMonth() + 1}.${min.getFullYear()}`,
                max: `${max.getDate()}.${max.getMonth() + 1}.${max.getFullYear()}`,
            }
            this.$emit('update:modelValue', value)
        }
    },
}
</script>

<style lang="scss" scoped>
.range-slider-container {
}
.range-slider-inputs {
    position: relative;
    display: flex;
    gap: 30px;
    padding: 16px;
    background-color: #fff;
    border: 1px solid rgba(0, 59, 103, 0.1);
    border-radius: 5px 5px 0 0;
    overflow: hidden;
    input {
        width: 100%;
        font-size: 14px;
        line-height: 22px;
        color: #000000;
        border: none;
        &::-webkit-inner-spin-button {
            display: none;
        }
    }
    &::after {
        content: '';
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
        width: 16px;
        height: 1px;
        background-color: #C5D9E6;
    }
}
.range-slider.noUi-target {
    :deep {
        height: 4px;
        border: none;
        &.noUi-horizontal {
            .noUi-handle {
                box-shadow: none;
                border: none;
                background-color: transparent;
                transform: translateY(-14%);
                // width: 25px;
                // height: 20px;
                background-image: url('/templates/project/assets/img/range-slider-handle.svg');
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
                &::before, &::after {
                    display: none;
                }
                &.noUi-handle-upper {
                    transform: translateY(-6px) rotate(180deg);
                }
            }
        }
        .noUi-base {

        }
        .noUi-connects {
            background-color: #C5D9E6;
        }
        .noUi-connect {
            background-color: #4ABAF1;
        }
        .noUi-touch-area {

        }
    }
}
</style>